import React from 'react';
import {
  ClockCircleOutlined,
  CodeOutlined,
  CheckCircleOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import styles from './InstructionTitle.scss';

const formatSubtitle = (totalQuestion, timer, t) => {
  const parts = [];

  if (timer > 0) {
    parts.push(
      <span key="timer">
        <ClockCircleOutlined className={styles['icon-secondary']} /> {timer}{' '}
        {t('instructions.minutes', { count: timer })}
      </span>,
    );
  }

  if (typeof totalQuestion === 'object' && totalQuestion !== null) {
    const { problems = 0, mcqs = 0 } = totalQuestion;

    if (problems > 0) {
      parts.push(
        <span key="problems">
          <CodeOutlined className={styles['icon-secondary']} /> {problems}{' '}
          {t('instructions.problem', { count: problems })}
        </span>,
      );
    }

    if (mcqs > 0) {
      parts.push(
        <span key="mcqs">
          <CheckCircleOutlined className={styles['icon-secondary']} /> {mcqs}{' '}
          {t('instructions.mcq', { count: mcqs })}
        </span>,
      );
    }
  } else if (typeof totalQuestion === 'number' && totalQuestion > 0) {
    parts.push(
      <span key="questions">
        <QuestionCircleOutlined className={styles['icon-secondary']} /> {totalQuestion}{' '}
        {t('instructions.question', { count: totalQuestion })}
      </span>,
    );
  }

  return parts.length > 0
    ? parts.reduce((acc, part, index) => {
        if (index === 0) return [part];
        return [...acc, ' | ', part];
      }, [])
    : null;
};

const InstructionTitle = ({ totalQuestion, timer, title }) => {
  const { t } = useTranslation('common');

  return (
    <div className={styles['title-container']}>
      <h2 className={styles['title-heading']}>{title}</h2>
      <p className={styles['title-subtitle']}>{formatSubtitle(totalQuestion, timer, t)}</p>
    </div>
  );
};

export default InstructionTitle;
